<template>
  <div class="trialCost">
    <p class="topTit">
      保费试算
    </p>
    <el-scrollbar>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="200px"
        class="trialForm"
        size="mini"
      >
        <el-form-item label="企业名称：" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="投保地区：" prop="name">
          <el-cascader
            v-model="form.applicationPCA"
            :options="regionArray"
            :props="{ children: 'child', label: 'name', value: 'id' }"
            filterable
            style="width:100%"
            popper-class="cascaderRegion"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="职业类别：" prop="workType">
          <el-select
            filterable
            v-model="workCateIds"
            placeholder="请选择"
            style="width:100%"
            @change="changeWorkCateIds"
          >
            <el-option
              v-for="(item, index) in workTypeArray"
              :key="item.value"
              :label="item.value"
              :value="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投保工种：" prop="workId">
          <el-cascader
            v-model="form.workId"
            :options="optionsArray"
            :props="{ children: 'child', label: 'title', value: 'id' }"
            filterable
            :key="cascaderKey"
            style="width:100%"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="投保人数：" prop="name">
          <el-input-number
            v-model="form.insureNum"
            controls-position="right"
            style="width:100%"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="投保年龄：" prop="name" class="ageBox">
          <el-form-item prop="name">
            <el-input-number
              v-model="form.name"
              controls-position="right"
              style="width:80px"
            ></el-input-number>
          </el-form-item>
          <span>——</span>
          <el-form-item prop="name">
            <el-input-number
              v-model="form.name"
              controls-position="right"
              style="width:80px"
            ></el-input-number>
          </el-form-item>
        </el-form-item>
        <el-form-item label="保障期限：" prop="guaranteePeriod">
          <el-select
            filterable
            v-model="form.guaranteePeriod"
            placeholder="请选择"
            style="width:100%"
          >
            <el-option
              v-for="(item, index) in monthArray"
              :key="index"
              :label="item + '个月'"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="伤残比例：" prop="disabRatio">
          <el-select
            filterable
            v-model="form.disabRatio"
            placeholder="请选择"
            style="width:100%"
          >
            <el-option label="十级伤残,1%" value="is_one_percent"> </el-option>
            <el-option label="十级伤残,3%" value="is_three_percent"> </el-option>
            <el-option label="十级伤残,5%" value="is_five_percent"> </el-option>
            <el-option label="十级伤残,7%" value="is_seven_percent"> </el-option>
            <el-option label="十级伤残,10%" value="is_ten_percent"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="24小时扩展：" prop="isAllDays" style="width:100%">
          <el-radio-group v-model="form.isAllDays">
            <el-radio label="0">不扩展</el-radio>
            <el-radio label="1">扩展</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="死亡/伤残限额（万元）：" prop="name">
          <el-select
            filterable
            v-model="form.name"
            placeholder="请选择"
            style="width:100%"
          >
            <el-option label="十级伤残,1%" :value="1"> </el-option>
            <el-option label="十级伤残,3%" :value="3"> </el-option>
            <el-option label="十级伤残,5%" :value="5"> </el-option>
            <el-option label="十级伤残,7%" :value="7"> </el-option>
            <el-option label="十级伤残,10%" :value="10"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医疗费用限额（万元）：" prop="name">
          <el-select
            filterable
            v-model="form.name"
            placeholder="请选择"
            style="width:100%"
          >
            <el-option label="十级伤残,1%" :value="1"> </el-option>
            <el-option label="十级伤残,3%" :value="3"> </el-option>
            <el-option label="十级伤残,5%" :value="5"> </el-option>
            <el-option label="十级伤残,7%" :value="7"> </el-option>
            <el-option label="十级伤残,10%" :value="10"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="误工费（元/天）：" prop="name">
          <el-select
            filterable
            v-model="form.disabRatio"
            placeholder="请选择"
            style="width:100%"
          >
            <el-option label="十级伤残,1%" :value="1"> </el-option>
            <el-option label="十级伤残,3%" :value="3"> </el-option>
            <el-option label="十级伤残,5%" :value="5"> </el-option>
            <el-option label="十级伤残,7%" :value="7"> </el-option>
            <el-option label="十级伤残,10%" :value="10"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="住院津贴：" prop="name">
          <el-select
            filterable
            v-model="form.name"
            placeholder="请选择"
            style="width:100%"
          >
            <el-option label="十级伤残,1%" :value="1"> </el-option>
            <el-option label="十级伤残,3%" :value="3"> </el-option>
            <el-option label="十级伤残,5%" :value="5"> </el-option>
            <el-option label="十级伤残,7%" :value="7"> </el-option>
            <el-option label="十级伤残,10%" :value="10"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="法律援助：" prop="name">
          <el-select
            filterable
            v-model="form.name"
            placeholder="请选择"
            style="width:100%"
          >
            <el-option label="十级伤残,1%" :value="1"> </el-option>
            <el-option label="十级伤残,3%" :value="3"> </el-option>
            <el-option label="十级伤残,5%" :value="5"> </el-option>
            <el-option label="十级伤残,7%" :value="7"> </el-option>
            <el-option label="十级伤残,10%" :value="10"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-scrollbar>
    <div class="trialBottom">
      <p class="price">
        保费：<span>￥{{ policyMoney }}</span>
      </p>
      <el-button @click="trialBtn">保费试算</el-button>
    </div>
  </div>
</template>
<script>
import {
  getProductTimeRule,
  getWorkType,
  getWork,
  getProductPlanMoney,
  getAreaList
} from "@/api/insure";
export default {
  name: "trialCost",
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      options: [],
      monthArray: [], //保障期限
      workTypeArray: [], //职业类别
      optionsArray: [], //工种
      workCateIds: 0, //工种选项下标
      policyMoney: "0.00", //价格
      regionArray: [], //地区选项
      form: {
        name: "",
        disabRatio: "is_five_percent", //伤残比例
        isAllDays: "0", //24小时
        guaranteePeriod: "", //投保期限
        workType: [], //职业类别
        workId: [], //工种id
        insureNum: 0, //投保人数
        applicationPCA: [] //投保地区
      },
      rules: {
        disabRatio: [
          { required: true, message: "伤残比例不能为空", trigger: "blur" }
        ],
        isAllDays: [
          { required: true, message: "是否扩展24小时不能为空", trigger: "blur" }
        ],
        guaranteePeriod: [
          { required: true, message: "投保期限不能为空", trigger: "blur" }
        ],
        workType: [
          { required: true, message: "职业类别不能为空", trigger: "blur" }
        ],
        workId: [{ required: true, message: "职业不能为空", trigger: "blur" }],
        insureNum: [
          { required: true, message: "投保人数不能为空", trigger: "blur" }
        ]
      },
      cascaderKey: 0
    };
  },
  mounted() {
    this.getProductTimeRule();
    this.getWorkType();
    this.getAreaList();
  },
  methods: {
    // 保障期限、起保日期
    getProductTimeRule() {
      let that = this;
      let _data = {
        product_id: this.id,
        identification: 1
      };
      getProductTimeRule(_data)
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.monthArray = res.data.month;
            that.form.guaranteePeriod = res.data.month[0];
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //获取职业类别
    getWorkType() {
      let that = this;
      getWorkType({ product_id: this.id })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.workTypeArray = res.data;
            that.workCateIds = 0;
            that.form.workType = that.workTypeArray[that.workCateIds].ids;
            that.getWork();
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //获取工种
    getWork() {
      let that = this;
      console.log(that.workTypeArray);
      console.log(that.workCateIds);
      getWork({ workCateIds: that.form.workType })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.optionsArray = res.data;
            if (res.data[0].id) {
              that.cascaderKey++;
              that.form.workId = [];
              that.form.workId.push(res.data[0].id);
              that.form.workId.push(res.data[0].child[0].id);
              that.form.workId.push(res.data[0].child[0].child[0].id);
              that.form.workId.push(res.data[0].child[0].child[0].child[0].id);
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 职业类别变化时触发获取工种
    changeWorkCateIds(e) {
      this.form.workType = this.workTypeArray[e].ids;
      this.getWork();
    },
    // 获取地区
    getAreaList() {
      let that = this;
      getAreaList()
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.regionArray = res.data;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 获取保费
    trialBtn() {
      let that = this;

      let _data = {
        product_id: that.id,
        planId: 44,
        disabRatio: that.form.disabRatio,
        isAllDays: that.form.isAllDays,
        guaranteePeriod: that.form.guaranteePeriod,
        workType: that.form.workType,
        workId: that.form.workId,
        insureNum: that.form.insureNum
      };
      that.$refs["form"].validate(valid => {
        if (valid) {
          getProductPlanMoney(_data)
            .then(function(res) {
              console.log(res);
              if (res.code == 1) {
                that.policyMoney = res.data.policyMoney;
              } else {
                that.$message.error(res.msg);
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.trialCost {
  .topTit {
    font-size: 18px;
    font-weight: 400;
    color: #000000;
    margin: 0 0 15px;
    border-bottom: 1px dotted #979797;
    text-align: center;
    padding: 10px;
  }
  .el-scrollbar__wrap {
    height: calc(100vh - 155px);
  }
  .trialForm {
    width: calc(100% - 35px);
    .ageBox .el-form-item__content {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .el-form-item {
        margin: 0;
      }
      .el-form-item + span {
        margin: 0 10px;
        color: #a6a5a5;
      }
    }
  }
  .trialBottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 40px;
    .price {
      color: #f63;
      font-size: 20px;
      span {
        font-size: 34px;
      }
    }
    .el-button {
      background: #ff6634;
      color: #fff;
    }
    .el-button:hover,
    .el-button:focus {
      background: #dc3a02;
      color: #fff;
    }
  }
}
.cascaderRegion .el-cascader-panel {
  max-height: 600px;
}
</style>
